import PropTypes from 'prop-types';

export default PropTypes.shape({
  name: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  uri: PropTypes.string.isRequired,
  impersonating: PropTypes.string,
});
